import { render, staticRenderFns } from "./kthy.vue?vue&type=template&id=5a461839"
import script from "./kthy.vue?vue&type=script&lang=js"
export * from "./kthy.vue?vue&type=script&lang=js"
import style0 from "./kthy.vue?vue&type=style&index=0&id=5a461839&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports